import { AdobeAnalyticsUserRole } from '@/hooks/AdobeAnalyticsHooks/AdobeAnalyticsUserRole';

export const ADMIN_ACCESS_GROUP = 'CES_ADMINS';
export const GLOBAL_ACCESS_GROUP = 'CESAPP_ALL';
export const COMMERCIAL_ACCESS_GROUP = 'CESAPP_COMMERCIAL_USERS';

export const USER_ACCESS_LEVEL = {
  ADMIN: 'ADMIN',
  GLOBAL_USER: 'GLOBAL_USER',
  LOCAL_USER: 'LOCAL_USER',
} as const;

export type UserAccessLevel = (typeof USER_ACCESS_LEVEL)[keyof typeof USER_ACCESS_LEVEL];

export const USER_ACCESS_GROUPS: Partial<Record<UserAccessLevel, string>> = {
  [USER_ACCESS_LEVEL.ADMIN]: ADMIN_ACCESS_GROUP,
  [USER_ACCESS_LEVEL.GLOBAL_USER]: GLOBAL_ACCESS_GROUP,
};
export interface UserInfo {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  countries: string[];
  isAdmin: boolean;
  accessLevel: UserAccessLevel;
  canSimulate: boolean;
  hasCommercialAccess: boolean;
  adobeAnalyticsRole: AdobeAnalyticsUserRole;
  sub: string;
}

export interface IdToken {
  token_use: string;
  given_name: string;
  family_name: string;
  email: string;
  identities: { userId: string }[];
  locale: string;
  sub: string;
}
